import { Component, OnInit, ViewChild } from '@angular/core';
import { EventTrackerService, UserActionType, Page } from '../../../services/event-tracker/event-tracker.service';
import { UserService } from '../../../services/user.service';
import {UserDetails, User, NotificationSetting} from '../../../../models/user';
import { UserDetailsComponent } from './user-details/user-details.component';
import { ChangePwdComponent } from './change-pwd/change-pwd.component';
import { ObjectUtils } from '../../../utils/object.utils';
import {NotificationSettingComponent} from './notification-setting/notification-setting.component';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
  selector: 'user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit {

  @ViewChild(UserDetailsComponent) userDetailsComponent: UserDetailsComponent;
  @ViewChild(ChangePwdComponent) changePwdComponent: ChangePwdComponent;
  @ViewChild(NotificationSettingComponent) notificationSettingComponent: NotificationSettingComponent;

  public currentUserDetails: UserDetails = new UserDetails();
  public errorMsg: string;
  public successMsg: string;
  public isUserDetailsChanged = false;
  public hasUpdatedPwd = false;
  public notificationSetting: NotificationSetting;

  constructor(private eventTracker: EventTrackerService,
              private userService: UserService,
              private modalService: ModalService) { }

  ngOnInit() {
    this.sendViewSettingsEvent();
    this.getCurrentUserInfo();
    this.getNotificationSetting();
  }

  getCurrentUserInfo() {
    this.userService.getCurrentUserInfo().subscribe(res => {
      if (res && res.data) {
        this.currentUserDetails = res.data;
      }
    });
  }

  afterUpdatePasswordCallback(evt) {
    this.hasUpdatedPwd = evt;
    if (evt) {
      this.userDetailsComponent.uploadProfilePicture(this.userDetailsComponent.selectedImage);
    }
  }

  saveUserData() {
    this.modalService.close();

    if (this.changePwdComponent.hasFormChanged() && !this.userDetailsComponent.userDetails.dirty && !this.userDetailsComponent.hasChangedImage) {
      this.isUserDetailsChanged = false;
      this.changePwdComponent.onSubmit();
    }
    if (this.changePwdComponent.hasFormChanged() && (this.userDetailsComponent.userDetails.dirty || this.userDetailsComponent.hasChangedImage)) {
      this.isUserDetailsChanged = true;
      this.changePwdComponent.onSubmit();
    }
    if (this.userDetailsComponent.hasChangedImage && this.changePwdComponent.hasFormEmpty()) {
        this.userDetailsComponent.uploadProfilePicture(this.userDetailsComponent.selectedImage);
    }
    if (this.userDetailsComponent.userDetails.dirty && !this.userDetailsComponent.hasChangedImage && this.changePwdComponent.hasFormEmpty()) {
        this.userDetailsComponent.onSubmitUserDetails();
    }
    if (this.notificationSettingComponent.hasChangedNotificationSettings()) {
      this.notificationSettingComponent.saveNotificationSetting();
    }
  }

  private getNotificationSetting() {
    this.userService.loadNotificationSetting().subscribe((res) => {
      if (res) {
        this.notificationSetting = res;
      }
    });
  }

  private sendViewSettingsEvent() {
    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.SETTINGS_PAGE, undefined, undefined, undefined, null, null);
  }

  get isDisableSaveBtn() {
    return (this.userDetailsComponent.userDetails.invalid && (this.userDetailsComponent.userDetails.touched || this.userDetailsComponent.userDetails.dirty))
          || (!this.changePwdComponent.isValidNewPwd);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/user-settings.component.ts